import type { User } from '$lib/types/user';
import type { RoleId } from '$lib/utils/roles';

const rolePriority: RoleId[] = ['SuperAdmin', 'Admin', 'User'];

function normalizeRole(value: string | null | undefined): RoleId | null {
    if (value === 'Admin' || value === 'User' || value === 'SuperAdmin') {
        return value;
    }

    return null;
}

function getUserRoles(user: User | null | undefined): RoleId[] {
    if (!user) return ['User'];

    const mergedRoles = [
        ...(Array.isArray(user.roles) ? user.roles : []),
        user.role
    ]
        .map((role) => normalizeRole(role))
        .filter((role): role is RoleId => role !== null);

    const uniqueRoles = Array.from(new Set(mergedRoles));

    if (uniqueRoles.length === 0) {
        return ['User'];
    }

    return [...uniqueRoles].sort((a, b) => rolePriority.indexOf(a) - rolePriority.indexOf(b));
}

export function hasRole(user: User | null | undefined, role: RoleId): boolean {
    return getUserRoles(user).includes(role);
}

export function hasAnyRole(user: User | null | undefined, roles: RoleId[]): boolean {
    const userRoles = getUserRoles(user);
    return roles.some((role) => userRoles.includes(role));
}
